<template>
  <div class="timeline-container d-flex flex-column h-100 bg-white">
    <div class="header d-flex justify-content-between align-items-center border-bottom" style="padding: 10px;">
      <div class="title fw-bold" style="font-size: 16px;">Lịch sử hoạt động</div>
      <el-popover placement="bottom-end" width="300" trigger="click">
        <div class="filter-popover">
          <div class="mb-2 fw-bold" style="font-size: 13px;">Loại hoạt động</div>
          <el-select v-model="filters.types" multiple placeholder="Chọn loại" size="small" class="w-100 mb-3" @change="onFilterChange">
            <el-option label="Tạo mới khách hàng" value="CREATE"></el-option>
            <el-option label="Cập nhật thông tin khách hàng" value="UPDATE"></el-option>
            <el-option label="Cập nhật quy trình" value="UPDATE_PROCESS"></el-option>
            <el-option label="Ghi chú" value="NOTE"></el-option>
            <el-option label="Lịch hẹn" value="APPOINTMENT"></el-option>
            <el-option label="Cập nhật lịch hẹn" value="APPOINTMENT_UPDATE"></el-option>
            <el-option label="Cuộc gọi" value="CALL"></el-option>
          </el-select>

          <div class="mb-2 fw-bold" style="font-size: 13px;">Thời gian</div>
          <el-date-picker
            v-model="filters.dateRange"
            type="daterange"
            size="small"
            range-separator="-"
            start-placeholder="Từ ngày"
            end-placeholder="Đến ngày"
            value-format="timestamp"
            class="w-100 mb-2"
            @change="onFilterChange"
          >
          </el-date-picker>
        </div>
        <el-button slot="reference" size="small" type="default" plain class="btn-filter">Lọc</el-button>
      </el-popover>
    </div>
    
    <div class="timeline-body p-3" style="overflow-y: auto; background-color: #f1f3f6; flex: 1; max-height: calc(80vh - 75px);">
      <div v-if="loading" class="text-center mt-3">
        <i class="el-icon-loading"></i> Đang tải dữ liệu...
      </div>
      <div v-else-if="groupedTimeline.length === 0" class="text-center text-muted mt-3">
        Không có lịch sử hoạt động.
      </div>

      <div v-for="group in groupedTimeline" :key="group.dateLabel" class="timeline-group">
        <div class="date-label fw-bold" style="font-size: 15px; color: #3d4653; position: sticky; top: -16px; z-index: 10; background-color: #f1f3f6; padding-top: 16px; padding-bottom: 12px; margin-top: -16px; margin-bottom: 16px;">
          {{ group.dateLabel }}
        </div>
        
        <el-timeline style="padding-left: 0;">
          <el-timeline-item
            v-for="item in group.items"
            :key="item.id"
            :color="getDotColor(item)"
            size="large"
            class="custom-timeline-item"
            style="padding-bottom: 6px !important;"
          >
            <div class="d-flex w-100 flex-column" style="margin-top: -6px;">
              <div class="d-flex justify-content-between">
                <span class="fw-bold" style="font-size: 13px;" :style="{ color: getTitleColor(item) }">
                  {{ item.title }}
                </span>
                <span class="text-muted" style="font-size: 12px;">{{ formatTime(item.timestamp) }}</span>
              </div>
              
              <div class="text-muted" style="font-size: 12px; margin-bottom: 4px; margin-top: 2px;">
                <span v-if="item.subTitle">{{ item.user }} {{ item.subTitle }}</span>
                <span v-else>{{ item.user }}</span>
              </div>

              <!-- Content Render based on type -->
              
              <!-- CALL -->
              <div v-if="item.type === 'CALL'" class="mt-1">
                <div class="d-flex align-items-center">
                  <span class="px-2 py-1 rounded" style="font-size: 11px; font-weight: 500;" 
                        :class="item.data.isAnswered ? 'bg-success-light text-success' : 'bg-danger-light text-danger'">
                    {{ item.data.isAnswered ? 'Đã nghe' : 'Không nghe' }}
                  </span>
                  <span v-if="item.data.isAnswered" class="ms-2 text-muted fw-bold" style="font-size: 12px;">
                    {{ item.data.duration }}
                  </span>
                </div>
              </div>

              <!-- NOTE -->
              <div v-else-if="item.type === 'NOTE'" class="mt-1 p-2 bg-white rounded border detail-box" style="font-size: 13px;">
                <div class="mb-1 fw-bold text-primary" style="font-size: 12px;" v-if="item.data.processWorkflowMsg">
                   {{ item.data.processWorkflowMsg }}
                </div>
                <div v-html="renderNoteWithMention(item.data)"></div>
              </div>

              <!-- APPOINTMENT -->
              <div v-else-if="item.type === 'APPOINTMENT' || item.type === 'APPOINTMENT_UPDATE'" class="mt-1 p-2 bg-white rounded border detail-box d-flex flex-column align-items-start" style="font-size: 13px;">
                <div class="d-flex w-100 align-items-center">
                  <span class="fw-bold me-2">{{ item.data.timeStr }}</span> — <span class="ms-2 text-truncate" style="max-width: 60%">{{ item.data.name }}</span>
                  <span v-if="item.data.statusInfo" class="ms-auto px-2 py-1 rounded text-nowrap" style="font-size: 11px; font-weight: 500;"
                    :style="{ color: item.data.statusInfo.color, backgroundColor: item.data.statusInfo.bgColor }">
                    {{ item.data.statusInfo.label }}
                  </span>
                </div>
                <div v-if="item.data.participantsStr" class="mt-1 w-100" style="font-size: 12.5px;">
                  <span class="fw-bold text-muted">Người tham gia:</span> {{ item.data.participantsStr }}
                </div>
                <div v-if="item.data.noteStr" class="mt-1 w-100" style="font-size: 12.5px;">
                  <span class="fw-bold text-muted">Ghi chú:</span> <span v-html="escapeHtml(item.data.noteStr)"></span>
                </div>
              </div>

              <!-- WORKFLOW (Chuyển bước single) -->
              <div v-else-if="item.type === 'WORKFLOW'" class="mt-1" style="font-size: 13px;">
                <span class="fw-bold text-dark">{{ item.data.oldWorkflow }}</span>
                <span class="mx-2 text-muted">→</span>
                <span class="fw-bold text-primary">{{ item.data.newWorkflow }}</span>
              </div>

              <!-- GROUP_UPDATE & UPDATE -->
              <div v-else-if="item.type === 'GROUP_UPDATE' || item.type === 'UPDATE'" class="mt-1" style="font-size: 13px;">
                <div class="d-flex flex-column align-items-start mt-1">
                  <div
                    v-for="(change, idx) in (item.data.changes ? item.data.changes : [item.data])"
                    :key="idx"
                    class="mb-2 custom-log-item"
                  >
                      <template v-if="change.isProcessSpecial">
                         <span :class="change.label === 'Thêm quy trình' ? 'text-primary' : (change.label === 'Đóng quy trình' ? 'text-danger' : 'text-success')">{{ change.label }} </span>
                         <span class="fw-bold mx-1" style="color: #3d4653;">{{ change.processName }}</span>
                         <span v-if="change.statusStr" class="px-2 py-1 rounded text-primary fw-bold ms-1" style="background-color: #e6f0fa; font-size: 11px;">{{ change.statusStr }}</span>
                      </template>
                      <template v-else>
                         <span>{{ change.fieldName }}:</span>
                         <span
                           v-if="!change.isCreate"
                           style="color: gray; text-decoration: line-through; margin-left: 4px;"
                         >{{ change.oldValue }}</span>
                         <span v-if="!change.isCreate" class="mx-1">-></span>
                         <span style="font-weight: 700" :class="change.isCreate ? 'text-dark' : 'text-primary'">
                           {{ change.newValue }}
                         </span>
                      </template>
                  </div>
                </div>
              </div>

              <!-- ADD PROCESS (Thêm quy trình lẻ) -->
              <div v-else-if="item.type === 'ADD_PROCESS'" class="mt-1 p-2 bg-white rounded border detail-box" style="font-size: 13px;">
                Thêm vào quy trình <span class="fw-bold">{{ item.data.processName }}</span>
                <span class="ms-2 px-2 py-1 rounded text-primary fw-bold" style="background-color: #e6f0fa; font-size: 11px;">Mở</span>
              </div>
              
              <!-- CREATE_CONTACT -->
              <div v-else-if="item.type === 'CREATE_CONTACT'" class="mt-1 p-2 bg-white rounded border detail-box" style="font-size: 13px;">
                <span class="fw-bold">Tạo mới liên hệ</span>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>

      <div v-if="hasMore" class="text-center mt-3 pb-3">
        <el-button type="primary" plain size="small" :loading="loadingMore" @click="fetchTimelineData(true)">
          Xem thêm
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/lib/http-common";

export default {
  name: "TimelineContact",
  props: ["contact", "workflows", "processList", "columnList", "app"],
  data() {
    return {
      loading: false,
      loadingMore: false,
      timelineItems: [],
      hasMore: false,
      nextTimestamp: null,
      nextLastId: null,
      filters: {
        types: [],
        dateRange: []
      }
    };
  },
  computed: {
    groupedTimeline() {
      // Sort items by timestamp descending
      const sorted = [...this.timelineItems].sort((a, b) => b.timestamp - a.timestamp);
      
      const groups = {};
      sorted.forEach(item => {
        const d = new Date(item.timestamp);
        // Format to string DD/MM/YYYY
        var day = ("0" + d.getDate()).slice(-2);
        var month = ("0" + (d.getMonth() + 1)).slice(-2);
        var year = d.getFullYear();
        const dateStr = `${day}/${month}/${year}`;
        
        let headerLabel = dateStr;
        
        // check if today
        const today = new Date();
        if (d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear()) {
          headerLabel = `HÔM NAY — ${dateStr}`;
        }

        if (!groups[headerLabel]) {
          groups[headerLabel] = [];
        }
        groups[headerLabel].push(item);
      });

      return Object.keys(groups).map(key => ({
        dateLabel: key,
        items: groups[key]
      }));
    }
  },
  mounted() {
    this.fetchTimelineData(false);
  },
  methods: {
    async fetchTimelineData(isLoadMore = false) {
      if (!this.contact || !this.contact.id) return;
      if (isLoadMore) {
        this.loadingMore = true;
      } else {
        this.loading = true;
      }

      try {
        const payload = {
          pageSize: 20,
          lastId: isLoadMore ? this.nextLastId : null,
          timestampAfter: isLoadMore ? this.nextTimestamp : null,
          contactId: this.contact.id,
          phone: this.contact.phone,
        };

        if (this.filters.types && this.filters.types.length > 0) {
          payload.types = this.filters.types;
        }
        if (this.filters.dateRange && this.filters.dateRange.length === 2) {
          payload.startDate = this.filters.dateRange[0];
          payload.endDate = this.filters.dateRange[1] + 86399999;
        }

        const res = await HTTP.post("/api/timeline", payload);
        if (res.status === 'success' && res.data) {
          this.hasMore = res.data.hasMore;
          this.nextTimestamp = res.data.nextTimestamp;
          this.nextLastId = res.data.nextLastId;

          const itemsData = res.data.data || [];
          let groupedData = {};
          let ungroupedData = [];

          // Phân loại data có groupId để gom chung
          itemsData.forEach(item => {
             if (item.groupId && (item.type === 'CREATE' || item.type === 'UPDATE' || item.type === 'UPDATE_PROCESS')) {
                if (!groupedData[item.groupId]) {
                   groupedData[item.groupId] = [];
                }
                groupedData[item.groupId].push(item);
             } else {
                ungroupedData.push([item]);
             }
          });

          // Trộn lại thành cấu trúc [ [item1, item2], [item3] ]
          let mergedGroups = [...ungroupedData, ...Object.values(groupedData)];
          // Sort theo element đầu tiên
          mergedGroups.sort((a,b) => b[0].createAt - a[0].createAt);

          let newItems = [];

          mergedGroups.forEach(groupArr => {
            let type0 = groupArr[0].type;
            if (groupArr.length === 1 && type0 !== 'CREATE' && type0 !== 'UPDATE' && type0 !== 'UPDATE_PROCESS') {
               let itemInfo = groupArr[0];
               let parsedData = {};
               if (itemInfo.data) {
                  let strData = itemInfo.data;
                  // Auto payload fix for malformed json without right-side property quotes (e.g., "status:"ANSWERD")
                  strData = strData.replace(/"([a-zA-Z0-9_]+):"/g, '"$1":"');
                  try {
                     parsedData = JSON.parse(strData);
                  } catch(e) {
                     console.log("TimelineContact JSON Parse Error:", e, strData);
                  }
               }

               let itemType = itemInfo.type;
               let title = '';
               let subTitle = '';
               let mappedData = {};

               if (itemType === 'NOTE') {
                  title = 'Ghi chú';
                  let msg = '';
                  if (parsedData.processWorkflow && Array.isArray(parsedData.processWorkflow)) {
                     const [procId, wfId] = parsedData.processWorkflow;
                     let wfName = '', procName = '';
                     if (this.app && this.app.processList && procId) {
                        const p = this.app.processList.find(proc => String(proc.id) === String(procId));
                        if (p) {
                           procName = p.name;
                           const wfs = p.workflowList || p.workflowDTOS || [];
                           const wObj = wfs.find(w => String(w.id) === String(wfId));
                           if (wObj) wfName = wObj.title || wObj.name;
                        }
                     }
                     if (!wfName && this.workflows && wfId) wfName = this.workflows.find(w => String(w.id) === String(wfId))?.title;
                     if (procName && wfName) msg = `Quy trình ${procName} - Bước ${wfName}`;
                  }
                  mappedData = { note: parsedData.note, mention: parsedData.mention, processWorkflowMsg: msg };
               } else if (itemType === 'APPOINTMENT' || itemType === 'APPOINTMENT_UPDATE') {
                  title = itemType === 'APPOINTMENT' ? 'Lịch hẹn mới' : 'Cập nhật lịch hẹn';
                  subTitle = itemType === 'APPOINTMENT' ? 'tạo lịch hẹn' : 'cập nhật lịch hẹn';
                  const statusInfo = this.getAppointmentStatusLogic(parsedData.status, parsedData.scheduledAt);
                  
                  let pStr = '';
                  try {
                    let pArray = typeof parsedData.participants === "string" ? JSON.parse(parsedData.participants) : parsedData.participants;
                    if (Array.isArray(pArray)) {
                       pStr = pArray.map(p => {
                          if (typeof p === 'string') {
                             const parts = p.split('_');
                             return parts.length > 1 ? parts[1] : p;
                          }
                          return p;
                       }).join(", ");
                    } else if (parsedData.participants) pStr = parsedData.participants;
                  } catch(e) { pStr = parsedData.participants; }

                  mappedData = { 
                     timeStr: parsedData.scheduledAt, 
                     name: parsedData.title || parsedData.name, 
                     statusInfo,
                     participantsStr: pStr,
                     noteStr: parsedData.note 
                  };
               } else if (itemType === 'CALL') {
                  const isOutbound = parsedData.direction === 'outbound' || !parsedData.direction;
                  title = isOutbound ? 'Cuộc gọi đi' : 'Cuộc gọi đến';
                  const isAnswered = parsedData.answerSec > 0 || parsedData.billSec > 0 || parsedData.isAnswered || parsedData.status === 'ANSWERED';
                  const durationStr = this.formatDuration(parsedData.answerSec || parsedData.billSec || parsedData.duration);
                  mappedData = { isAnswered: isAnswered, duration: durationStr };
               } else if (itemType === 'CREATE_CONTACT' || itemType === 'CREATE' && itemInfo.columnCode === 'contact') {
                  itemType = 'CREATE_CONTACT';
                  title = 'Tạo mới liên hệ';
               }

               newItems.push({
                 id: itemInfo.id || `single_${itemInfo.createAt}_${Math.random()}`,
                 timestamp: itemInfo.createAt,
                 type: itemType,
                 title: title,
                 user: itemInfo.username || itemInfo.createdBy || 'Hệ thống',
                 subTitle: subTitle,
                 data: mappedData
               });
            } else {
               // Nhóm CREATE / UPDATE / UPDATE_PROCESS
               let title = 'Cập nhật thông tin';
               let user = groupArr[0].username || groupArr[0].createdBy;
               let timestamp = groupArr[0].createAt;
               let changes = [];
               
               let isAllCreate = groupArr.every(x => x.type === 'CREATE');
               if (groupArr.some(x => x.columnCode === 'contact' || x.type === 'CREATE')) {
                  title = 'Tạo mới liên hệ';
               } else if (groupArr.some(x => x.type === 'UPDATE_PROCESS')) {
                  title = 'Cập nhật quy trình';
               }

               groupArr.forEach(itemInfo => {
                  if (itemInfo.columnCode === 'contact') return; // Skip base trigger
                  
                  let parsedData = {};
                  try { if (itemInfo.data) parsedData = JSON.parse(itemInfo.data); } catch(e){console.log(e);
                  }

                  const fieldName = this.getFieldName(itemInfo.columnCode);
                  if (itemInfo.columnCode === 'workflow') {
                      let oldArr = [];
                      try { if(parsedData.oldValue) oldArr = JSON.parse(parsedData.oldValue); }catch(e){console.log(e);}
                      if (!Array.isArray(oldArr)) oldArr = [oldArr].filter(Boolean);

                      let newArr = [];
                      try { if(parsedData.newValue) newArr = JSON.parse(parsedData.newValue); }catch(e){console.log(e);}
                      if (!Array.isArray(newArr)) newArr = [newArr].filter(Boolean);

                      newArr.forEach(nItem => {
                         if (!nItem) return;
                         let oItem = oldArr.find(o => o && o.processId === nItem.processId);
                         let pName = this.getProcessNameFromApp(nItem.processId);
                         
                         if (oItem && oItem.workflowId !== nItem.workflowId) {
                            let oldWfN = this.getWfNameFromApp(nItem.processId, oItem.workflowId);
                            let newWfN = this.getWfNameFromApp(nItem.processId, nItem.workflowId);
                            changes.push({
                               fieldName: 'Quy trình/Bước',
                               oldValue: pName && pName !== 'Không xác định' ? `${oldWfN} (${pName})` : oldWfN,
                               newValue: pName && pName !== 'Không xác định' ? `${newWfN} (${pName})` : newWfN,
                               isCreate: false
                            });
                         } else if (!oItem) {
                            let newWfN = this.getWfNameFromApp(nItem.processId, nItem.workflowId);
                            changes.push({
                               fieldName: 'Quy trình/Bước',
                               oldValue: "Chưa có",
                               newValue: pName && pName !== 'Không xác định' ? `${newWfN} (${pName})` : newWfN,
                               isCreate: false
                            });
                         }
                      });
                      if (changes.length === 0) {
                         changes.push({
                            fieldName: 'Bước',
                            oldValue: this.parseFieldValue(itemInfo.columnCode, parsedData.oldValue), 
                            newValue: this.parseFieldValue(itemInfo.columnCode, parsedData.newValue),
                            isCreate: false
                         });
                      }
                  } else if (itemInfo.columnCode === 'process') {
                     let isObjProcessUpdate = false;
                     let processValue = parsedData.newValue;
                     try {
                        let objVal = JSON.parse(processValue);
                        if (Array.isArray(objVal) && objVal.length > 0 && objVal[0].status) {
                           isObjProcessUpdate = true;
                        }
                     } catch(e) {
                      console.log(e);
                     }

                     if (isObjProcessUpdate) {
                         let oldArr = [];
                         try { if(parsedData.oldValue) oldArr = JSON.parse(parsedData.oldValue); }catch(e){console.log(e);}
                         if (!Array.isArray(oldArr)) oldArr = [oldArr].filter(Boolean);

                         let newArr = [];
                         try { if (parsedData.newValue) newArr = JSON.parse(parsedData.newValue); }catch(e){console.log(e);}
                         if (!Array.isArray(newArr)) newArr = [newArr].filter(Boolean);

                         newArr.forEach(nItem => {
                             if (!nItem) return;
                             let oItem = oldArr.find(o => o && o.processId === nItem.processId);
                             let pName = this.getProcessNameFromApp(nItem.processId);
                             
                             if (!oItem) {
                                 changes.push({
                                     isProcessSpecial: true,
                                     label: 'Thêm quy trình',
                                     processName: pName,
                                     statusStr: nItem.status === 'OPEN' ? 'Mở' : nItem.status
                                 });
                             } else if (oItem.status !== nItem.status) {
                                 changes.push({
                                     isProcessSpecial: true,
                                     label: nItem.status === 'CLOSE' ? 'Đóng quy trình' : 'Mở quy trình',
                                     processName: pName,
                                     statusStr: null
                                 });
                             }
                         });
                     } else {
                         let pName = this.getProcessNameFromApp(parsedData.newValue);
                         changes.push({
                             isProcessSpecial: true,
                             label: 'Thêm quy trình',
                             processName: pName,
                             statusStr: 'Mở'
                         });
                     }
                  } else {
                     changes.push({
                        fieldName: fieldName,
                        oldValue: this.parseFieldValue(itemInfo.columnCode, parsedData.oldValue),
                        newValue: this.parseFieldValue(itemInfo.columnCode, parsedData.newValue),
                        isCreate: itemInfo.type === 'CREATE'
                     });
                  }
               });

               const uniqueChanges = [];
               changes.forEach(c => {
                  if (!uniqueChanges.some(u => 
                     u.fieldName === c.fieldName && 
                     u.oldValue === c.oldValue && 
                     u.newValue === c.newValue && 
                     u.isProcessSpecial === c.isProcessSpecial && 
                     u.label === c.label &&
                     u.processName === c.processName
                  )) {
                     uniqueChanges.push(c);
                  }
               });
               changes = uniqueChanges;

               newItems.push({
                 id: groupArr[0].groupId || `grp_${timestamp}_${Math.random()}`,
                 timestamp: timestamp,
                 type: groupArr.length > 1 ? 'GROUP_UPDATE' : (isAllCreate ? 'UPDATE' : 'UPDATE'),
                 title: title,
                 user: user || 'Hệ thống',
                 subTitle: '',
                 data: groupArr.length > 1 ? { changes } : { ...changes[0] }
               });
            }
          });

          if (isLoadMore) {
            this.timelineItems = [...this.timelineItems, ...newItems];
          } else {
            this.timelineItems = newItems;
          }
        }
      } catch (error) {
        console.error("Fetch timeline data failed", error);
      } finally {
        this.loading = false;
        this.loadingMore = false;
      }
    },

    onFilterChange() {
      this.nextLastId = null;
      this.nextTimestamp = null;
      this.hasMore = false;
      this.timelineItems = [];
      this.fetchTimelineData(false);
    },

    getDotColor(item) {
      if (item.type === 'CALL') return item.data && item.data.isAnswered ? '#23b355' : '#e24141';
      if (item.type === 'NOTE') return '#293240';
      if (item.type === 'APPOINTMENT' || item.type === 'APPOINTMENT_UPDATE') return '#293240';
      if (item.type === 'GROUP_UPDATE' || item.type === 'UPDATE') return '#293240';
      return '#293240';
    },

    getTitleColor(item) {
      if (item.type === 'CALL') return item.data && item.data.isAnswered ? '#23b355' : '#e24141';
      if (item.type === 'NOTE') return '#3d4653';
      return '#3d4653';
    },

    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      return `${hours}:${minutes}`;
    },

    formatDuration(duration) {
      if (!duration) return "0s";
      const durationNum = Number(duration);
      if (isNaN(durationNum)) return "0s";
      const hours = Math.floor(durationNum / 3600);
      const minutes = Math.floor((durationNum % 3600) / 60);
      const seconds = Math.floor(durationNum % 60);
      if (hours > 0) return `${hours}h ${minutes}p ${seconds}s`;
      if (minutes > 0) return `${minutes}p ${seconds}s`;
      return `${seconds}s`;
    },

    getAppointmentStatusLogic(statusStr, scheduledAt) {
       if (statusStr === 'DONE') return { label: 'Hoàn thành', color: '#23b355', bgColor: '#e6f6eb' };
       if (statusStr === 'CANCEL') return { label: 'Đã hủy', color: '#6c757d', bgColor: '#e9ecef' };
       
       let now = new Date();
       if (scheduledAt) {
          try {
             let parts = scheduledAt.split(', ');
             if (parts.length === 2) {
                let datePart = parts[0]; 
                let timeParts = parts[1].split(' - '); 
                
                let dateArr = datePart.split('/');
                if (dateArr.length === 3 && timeParts.length === 2) {
                   let day = parseInt(dateArr[0]);
                   let month = parseInt(dateArr[1]) - 1;
                   let year = parseInt(dateArr[2]);
                   
                   let startArr = timeParts[0].split(':');
                   let endArr = timeParts[1].split(':');
                   
                   let startDate = new Date(year, month, day, parseInt(startArr[0] || 0), parseInt(startArr[1] || 0));
                   let endDate = new Date(year, month, day, parseInt(endArr[0] || 0), parseInt(endArr[1] || 0));
                   
                   if (now < startDate) {
                      return { label: 'Chưa bắt đầu', color: '#6c757d', bgColor: '#e9ecef' };
                   } else if (now > endDate) {
                      return { label: 'Quá hạn', color: '#e24141', bgColor: '#fbecec' };
                   } else {
                      return { label: 'Đang diễn ra', color: '#e6a23c', bgColor: '#fdf6ec' };
                   }
                }
             }
          } catch(e) { console.log(e); }
       }
       return { label: 'Chưa bắt đầu', color: '#6c757d', bgColor: '#e9ecef' };
    },

    getProcessNameFromApp(id) {
       if (!id || !this.app || !this.app.processList) return id || "Không xác định";
       const p = this.app.processList.find(proc => String(proc.id) === String(id));
       return p ? p.name : id;
    },

    getWfNameFromApp(processId, wfId) {
       if (!processId || !wfId || !this.app || !this.app.processList) return wfId;
       const p = this.app.processList.find(proc => String(proc.id) === String(processId));
       if (p) {
          const wfs = p.workflowList || p.workflowDTOS || [];
          const w = wfs.find(wf => String(wf.id) === String(wfId));
          if (w) return w.title || w.name;
       }
       return wfId;
    },

    getFieldName(columnCode) {
      if (columnCode === 'status') return 'Trạng thái';
      if (columnCode === 'workflow') return 'Bước';
      if (!this.columnList) return columnCode;
      const column = this.columnList.find((c) => c.name === columnCode);
      return column ? column.title : columnCode;
    },

    parseValue(value) {
      if (typeof value === "string" && value.startsWith("[") && value.endsWith("]")) {
        try {
          let parsed = JSON.parse(value);
          if (Array.isArray(parsed)) return parsed.join(", ");
        } catch (error) {
          console.log(error);
          // fallback
        }
      }
      return value === null || value === undefined ? "Trống" : value;
    },

    parseFieldValue(columnCode, value) {
      if (value === null || value === undefined) return "Trống";
      
      let parsed = value;
      if (typeof value === "string" && value.startsWith("[") && value.endsWith("]")) {
         try { parsed = JSON.parse(value); } catch(e){console.log(e);}
      }

      if (columnCode === 'storage') {
         let storage = this.app?.storageAll?.find(st => String(st.id) === String(value));
         return storage ? storage.name : value;
      }
      if (columnCode === 'status') {
         if (value === 'ACTIVE') return 'Đã xác nhận';
         if (value === 'INACTIVE') return 'Chờ xác nhận';
         return value;
      }
      if (columnCode === 'employees') {
         let arr = [];
         if (typeof value === 'string' && value.startsWith("[") && value.endsWith("]")) {
            arr = value.substring(1, value.length - 1).split(',').map(s => s.trim()).filter(Boolean);
         } else {
            arr = Array.isArray(parsed) ? parsed : [parsed];
         }
         return arr.map(val => {
            if (!val || typeof val !== 'string') return val;
            const parts = val.split('_');
            let rightPart = parts.length > 1 ? parts[1] : parts[0];
            const slashParts = rightPart.split('/');
            return slashParts.length > 1 ? slashParts[1] : slashParts[0];
         }).join(", ");
      }
      if (columnCode === 'workflow') {
         let arr = Array.isArray(parsed) ? parsed : [parsed];
         let names = arr.map(wf => {
           if (wf && wf.workflowId) {
              let processName = '', wfName = '';
              if (this.app && this.app.processList && wf.processId) {
                 const p = this.app.processList.find(proc => String(proc.id) === String(wf.processId));
                 if (p) {
                    processName = p.name;
                    const wfs = p.workflowList || p.workflowDTOS || [];
                    const wObj = wfs.find(w => String(w.id) === String(wf.workflowId));
                    if (wObj) wfName = wObj.title || wObj.name;
                 }
              }
              if (!wfName && this.workflows) {
                  const w = this.workflows.find(w => String(w.id) === String(wf.workflowId));
                  if (w) wfName = w.title || w.name;
              }
              return processName && wfName ? `${wfName} (${processName})` : (wfName || wf.workflowId);
           }
           return wf;
         });
         return names.join(", ");
      }
      if (columnCode === 'process_status') {
          let arr = Array.isArray(parsed) ? parsed : [parsed];
          let names = arr.map(wf => {
             if (wf && wf.processId) {
                let processName = '';
                if (this.processList && wf.processId) {
                   const p = this.processList.find(proc => proc.id === wf.processId);
                   if (p) processName = p.name;
                }
                let statusStr = wf.status === 'CLOSE' ? 'Đóng' : (wf.status === 'OPEN' ? 'Mở' : wf.status);
                return processName ? `${processName} (${statusStr})` : statusStr;
             }
             return wf;
          });
          return names.join(", ");
      }
      if (columnCode === 'process_new') {
          let processName = value;
          if (this.processList) {
             const p = this.processList.find(proc => String(proc.id) === String(value));
             if (p) processName = p.name;
          }
          return processName;
      }
      
      if (Array.isArray(parsed)) return parsed.join(", ");
      return value;
    },

    getProcessNameFromLog(valueNew) {
      if (!valueNew) return "Không xác định";
      try {
        let parsed = JSON.parse(valueNew);
        if (Array.isArray(parsed) && parsed.length > 0 && this.processList) {
           const p = this.processList.find(proc => proc.id === parsed[0].processId);
           return p ? p.name : "Không xác định";
        }
      } catch (e) {
        console.log(e);
        // ignore
      }
      return valueNew;
    },

    renderNoteWithMention(data) {
      if (!data || !data.note) return 'Không có ghi chú';
      if (!data.mention) return this.escapeHtml(data.note);

      let mentions = [];
      try {
        mentions = JSON.parse(data.mention);
      } catch (e) {
        return this.escapeHtml(data.note);
      }
      if (!mentions.length) return this.escapeHtml(data.note);

      let result = '';
      let lastIndex = 0;
      mentions.sort((a, b) => a.start - b.start).forEach(m => {
        result += this.escapeHtml(data.note.slice(lastIndex, m.start));
        result += `<span class="fw-bold" style="color: #3178c6;">@${m.name}</span>`;
        lastIndex = m.start + m.length;
      });
      result += this.escapeHtml(data.note.slice(lastIndex));
      return result;
    },

    escapeHtml(text) {
      return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/\n/g, '<br>');
    }
  }
};
</script>

<style scoped>
.bg-success-light { background-color: #e6f6eb; }
.text-success { color: #23b355; }
.bg-danger-light { background-color: #fbecec; }
.text-danger { color: #e24141; }

.timeline-container {
  border-left: 1px solid #ececec;
}

.timeline-group .el-timeline-item {
  padding-bottom: 20px;
}

.custom-timeline-item {
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: normal;
}

.custom-log-item {
  background-color: #ffffff;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  box-shadow: 0 1px 2px rgba(0,0,0,0.02);
  color: #3d4653;
}

.custom-timeline-item :deep(.el-timeline-item__node) {
  background-color: #555;
  width: 8px;
  height: 8px;
  left: 1px;
}

.custom-timeline-item :deep(.el-timeline-item__tail) {
  border-left: 1px solid #e0e0e0;
  left: 4px;
}

.detail-box {
  margin-top: 8px;
  padding: 10px;
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid #ebeef5;
  font-size: 13px;
  color: #3d4653;
}
</style>
